var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadTunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 0.0400085C7.35825 0.0944713 4.84641 1.19643 3.01734 3.10333C1.18827 5.01023 0.191884 7.56579 0.247494 10.2075V18.5075C0.248327 18.8621 0.378131 19.2043 0.612694 19.4703C0.730977 19.6026 0.900069 19.678 1.07749 19.6778C1.25685 19.6878 1.42997 19.6105 1.54229 19.4703L7.97479 12.2825C8.07591 12.1679 8.13195 12.0204 8.13249 11.8675V9.79251C8.13249 8.65541 8.71349 7.51001 9.99999 7.51001C11.2865 7.51001 11.8675 8.65541 11.8675 9.79251V11.8675C11.868 12.0204 11.9241 12.1679 12.0252 12.2825L18.4577 19.4703C18.576 19.6026 18.7451 19.678 18.9225 19.6778C19.0999 19.678 19.269 19.6026 19.3873 19.4703C19.6219 19.2043 19.7517 18.8621 19.7525 18.5075V10.2075C19.8081 7.56579 18.8117 5.01023 16.9826 3.10333C15.1536 1.19643 12.6417 0.0944713 9.99999 0.0400085V0.0400085Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.055C9.5416 17.055 9.17 17.4266 9.17 17.885V19.13C9.17 19.5884 9.5416 19.96 10 19.96C10.4584 19.96 10.83 19.5884 10.83 19.13V17.885C10.83 17.4266 10.4584 17.055 10 17.055Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.1125C9.5416 13.1125 9.17 13.4841 9.17 13.9425V15.1875C9.17 15.6459 9.5416 16.0175 10 16.0175C10.4584 16.0175 10.83 15.6459 10.83 15.1875V13.9425C10.83 13.4841 10.4584 13.1125 10 13.1125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadTunnel);
export default __webpack_public_path__ + "static/media/roadTunnel.04b9d507d21e41226439de90bfeaa155.svg";
export { ForwardRef as ReactComponent };